<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingPage">
        <div slot="body">
          <bita-form ref="form">
            <div slot="body">
              <!-- فیلترهای اصلی -->
              <div class="row">
                <bita-input
                  name="title"
                  label="عنوان نوتیفیکیشن"
                  input-class="form-control"
                  validation-container-class="col-3"
                  v-model="formData.title"
                  rules="required"
                  required
                />
              
                <bita-input
                  name="smart_number"
                  label="شماره هوشمند"
                  input-class="form-control"
                  validation-container-class="col-3"
                  v-model="formData.smart_number"
                />
                <bita-input
                  name="national_code"
                  label="کد ملی"
                  input-class="form-control"
                  validation-container-class="col-3"
                  v-model="formData.national_code"
                />
                <bita-input
                  name="city_code"
                  label="کد شهر (دو رقم اول پلاک)"
                  input-class="form-control"
                  validation-container-class="col-3"
                  type="number"
                  placeholder="مثلاً 54 یا 64"
                  v-model="formData.city_code"
                />

              </div>

              <!-- نوع خودرو -->
              <div class="row">
                                <bita-select
                  name="is_active"
                  label="وضعیت کاربر"
                  input-class="form-control"
                  validation-container-class="col-3"
                  :data-source="statusOptions"
                  data-text-field="text"
                  data-value-field="value"
                  v-model="formData.is_active"
                />
                <bita-select
                  name="vehicle_type_parent"
                  label="دسته‌بندی نوع ماشین"
                  validation-container-class="col-3"
                  input-class="form-control"
                  :data-source="vehicleTypeParent"
                  data-text-field="name"
                  data-value-field="id"
                  @change="getVehicleTypeChildren"
                />
                <Spinner
                  :is-loading="isLoadingVehicleType"
                  class-name="col-3"
                  styleName="align-self: center;"
                />
                <bita-select
                  v-show="!isLoadingVehicleType"
                  name="vehicle_type_id"
                  label="نوع ماشین"
                  validation-container-class="col-3"
                  input-class="form-control"
                  :data-source="vehicleType"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="formData.vehicle_type_id"
                />
                                <bita-input
                  name="link"
                  label="لینک (اختیاری)"
                  input-class="form-control"
                  validation-container-class="col-3"
                  v-model="formData.link"
                />
              </div>

              <!-- پیام -->
              <div class="row">
                <bita-textarea
                  name="message"
                  label="متن پیام"
                  input-class="form-control"
                  validation-container-class="col-12"
                  place-holder="متن پیام نوتیفیکیشن"
                  v-model="formData.message"
                />
              </div>

              <!-- دکمه ارسال -->
              <div class="row mb-3">
                <bita-bootbutton
                  type="primary"
                  title="ارسال"
                  btn-width="150px"
                  @click.native="handleSendMessage"
                />
              </div>
            </div>
          </bita-form>
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "ارسال نوتیفیکیشن", link: "/notifications/send" },
      ],
      isLoadingPage: false,
      isLoadingVehicleType: false,
      vehicleTypeParent: [],
      vehicleType: [],
      formData: {},
      statusOptions: [
        { value: 1, text: "فعال" },
        { value: 0, text: "غیرفعال" },
      ],
    };
  },
  mounted() {
    this.loadVehicleTypeParent();
  },
  methods: {
    loadVehicleTypeParent() {
      this.isLoadingPage = true;
      this.$persistClient("get", "vehicle-types?filter[parent]=0")
        .then((res) => {
          this.vehicleTypeParent = res.data;
        })
        .finally(() => {
          this.isLoadingPage = false;
        });
    },
    getVehicleTypeChildren(parentId) {
      this.isLoadingVehicleType = true;
      this.$persistClient("get", `vehicle-types?filter[parent]=${parentId}`)
        .then((res) => {
          this.vehicleType = res.data;
        })
        .finally(() => {
          this.isLoadingVehicleType = false;
        });
    },
    handleSendMessage() {
      this.$refs.form.validate().then((isValid) => {
        if (!isValid) return;
        this.isLoadingPage = true;
        this.$persistClient("post", "send-notification", this.formData)
          .then((res) => {
            this.$izitoast("success", "موفق", res.data.message);
          })
          .finally(() => {
            this.isLoadingPage = false;
          });
      });
    },
  },
};
</script>
